import React from "react";
import { iconProps } from "../../../Helper";

export const TitleGeneratorIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        className={className}
        d="M3.16675 13.6667H12.8334C12.9601 13.6667 13.082 13.7148 13.1746 13.8013C13.2672 13.8878 13.3235 14.0062 13.3321 14.1326C13.3407 14.259 13.3011 14.3839 13.2211 14.4822C13.1412 14.5805 13.0269 14.6447 12.9014 14.662L12.8334 14.6667H3.16675C3.04007 14.6666 2.91812 14.6185 2.82555 14.532C2.73299 14.4455 2.6767 14.3271 2.66806 14.2007C2.65943 14.0744 2.69909 13.9494 2.77904 13.8511C2.85898 13.7529 2.97325 13.6886 3.09875 13.6713L3.16675 13.6667ZM10.8334 2C11.4965 2 12.1323 2.26339 12.6012 2.73223C13.07 3.20107 13.3334 3.83696 13.3334 4.5V10.1667C13.3334 10.8297 13.07 11.4656 12.6012 11.9344C12.1323 12.4033 11.4965 12.6667 10.8334 12.6667H5.16675C4.50371 12.6667 3.86782 12.4033 3.39898 11.9344C2.93014 11.4656 2.66675 10.8297 2.66675 10.1667V4.5C2.66675 3.83696 2.93014 3.20107 3.39898 2.73223C3.86782 2.26339 4.50371 2 5.16675 2H10.8334ZM10.8334 3H5.16675C4.76892 3 4.38739 3.15804 4.10609 3.43934C3.82478 3.72064 3.66675 4.10218 3.66675 4.5V10.1667C3.66675 10.5645 3.82478 10.946 4.10609 11.2273C4.38739 11.5086 4.76892 11.6667 5.16675 11.6667H10.8334C11.2312 11.6667 11.6128 11.5086 11.8941 11.2273C12.1754 10.946 12.3334 10.5645 12.3334 10.1667V4.5C12.3334 4.10218 12.1754 3.72064 11.8941 3.43934C11.6128 3.15804 11.2312 3 10.8334 3Z"
        fill="white"
      />
    </svg>
  );
};
